import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';

interface SubPageHeaderProps {
  title: string;
  icon?: React.ReactNode;
}

export default function SubPageHeader({ title, icon }: SubPageHeaderProps) {
  const navigate = useNavigate();

  return (
    <div style={{
      backgroundColor: '#003366',
      color: 'white',
      padding: '1rem 2rem',
      display: 'flex',
      alignItems: 'center',
      gap: '1rem'
    }}>
      <button
        onClick={() => navigate('/')}
        style={{
          background: 'none',
          border: 'none',
          color: 'white',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          fontSize: '1rem'
        }}
      >
        <ArrowLeft size={20} /> Zurück
      </button>
      <h1 style={{ margin: 0, fontSize: '1.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        {icon} {title}
      </h1>
    </div>
  );
}
